<template>
    <div class="lock-pp">
        <div class="lock-btn" @click="$emit('click')">
            <LockDefault :statusLock="getStatusLock" />

            <div class="lock-msg" v-if="getStatusLock === 0 && getLockMesg.length">
                <span>{{ getLockMesg }}</span>
            </div>

            <div class="unlock-msg" v-if="getStatusLock === 1 && getUnlockMesg.length">
                <span>{{ getUnlockMesg }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import LockDefault from '@/ui/lock-default/LockDefault'
export default {
    components: { LockDefault },
    name: 'LockPP',
    props: {
        statusLock: {
            default: 1
        },
        lockMsg: {
            type: String,
            default: ''
        },
        unlockMsg: {
            type: String,
            default: ''
        }
    },
    computed: {
        getStatusLock() {
            return this.statusLock
        },
        getLockMesg() {
            return this.lockMsg
        },
        getUnlockMesg() {
            return this.unlockMsg
        }
    }
}
</script>

<style scope src="./LockPP-light-theme.css"></style>
<style scope src="./LockPP-dark-theme.css"></style>



// WEBPACK FOOTER //
// src/ui/lock-pp/LockPP.vue